
export const billingTermSchema = {
    name: '{ type:"input", rules:"required"}',
    description: '{ type:"textarea", rules:"required"}',
    days: '{ type:"input", rules:"required|numeric|min_value^:0", inputType:"number" }',
    default: '{type:"switch"}',
}